<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="entity"
        :rules="validRules"
        label-width="80px"
        style="height: auto"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-autocomplete
                style="width: 90%"
                value-key="code"
                size="mini"
                class="inline-input"
                v-model="entity.projectName"
                :fetch-suggestions="querySearch"
                placeholder="请输入项目名称并选择"
                @select="handleSelect"
                :trigger-on-focus="true"
                @clear="clearSelect"
                clearable
              >
                <template slot-scope="{ item }">
                  <span>{{ item.name }}({{ item.code }})</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目模块" prop="module">
              <el-select
              style="width: 90%"
                v-model="entity.module"
                clearable
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in modules"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工作类别" prop="jobCode">
              <el-select
              style="width: 90%"
                v-model="entity.jobCode"
                clearable
                @change="jobChange"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in jobs"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投入工时" prop="actualValue">
              <el-input-number
              style="width: 90%"
                v-model="entity.actualValue"
                controls-position="right"
                size="mini"
                :min="1"
                :max="100"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="工作内容" prop="content" style="height: 300px">
          <!-- <el-input
            type="textarea"
            :rows="8"
            style="width: 700px"
            placeholder="请输入工作内容"
            v-model="entity.content"
          >
          </el-input> -->
          <quill-editor
            v-model="entity.content"
            style="height: 200px; width: 100%"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button
          type="primary"
          size="mini"
          style="width: 150px"
          @click="submit"
          >提交</el-button
        >
        <el-button
          type="danger"
          size="mini"
          style="margin-left: 20px; width: 150px"
          @click="close"
          >关闭</el-button
        >
      </div>
    </div>
    <!-- <LabelHeader msg="工时明细"></LabelHeader>
        <el-table ref="table" :data="items" loading="loading" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" stripe border>
            <af-table-column prop="projectName" label="项目名称" align="center" ></af-table-column>
            <af-table-column prop="module" label="项目模块" align="center" ></af-table-column>

            <af-table-column prop="jobName" label="工作类别" align="center" ></af-table-column>
            <af-table-column prop="actualValue" label="工时" align="center" ></af-table-column>
            <af-table-column prop="createAt" label="创建时间" align="center" ></af-table-column>
            <af-table-column prop="updateAt" label="修改时间" align="center" ></af-table-column>
            <af-table-column prop="content" label="工作内容" align="center" ></af-table-column>
            <af-table-column label="操作" align="center" :width="100">
                <template slot-scope="scope">
              
                    <el-link type="primary"  :underline="false" @click="openEditDialog(scope.row)">修改</el-link>&nbsp;
                    <el-popconfirm title="请确定要删除吗？"  @confirm="deleteRow(scope.row.id)" :key="scope.row.id">
                        <el-link type="danger"  slot="reference" :underline="false" >删除</el-link>
                    </el-popconfirm>
                </template>
            </af-table-column>
        </el-table>
        <div style="margin-top: 15px; display: flex; flex-wrap: nowrap; padding: 10px; justify-content: flex-end">
            <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="pagination.total"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :page-size="pagination.size"
            >
            </el-pagination>
        </div> -->
  </div>
</template>

<script>
import LabelHeader from "../../../eap/components/LabelHeader";
import moock from "../../../../dxrj.sdk/js/kit/moock";
export default {
  props: ["sheetId"],
  data() {
    return {
      editorOption: {
        placeholder: "请输入工作内容",
        modules: {
          toolbar: {
            container: [],
          },
        },
      },
      items: [], // 数据集合
      searchParams: {
        // 查询参数
        pageNo: 1,
        pageSize: 10,
        sheetId: "",
      },
      project: {},
      projects: [],
      plans: [],
      idVal: "",
      entity: {
        sheetId: this.sheetId,
        module: "",
        jobCode: "",
        jobName: "",
        projectCode: "",
        projectName: "",
        actualValue: 8,
        createAt: "",
        content: "",
      },
      from: {
        sheetId: this.sheetId,
        id: "",
        module: "",
        jobCode: "",
        jobName: "",
        projectCode: "",
        projectName: "",
        actualValue: 8,
        createAt: "",
        content: "",
      },
      validRules: {
        projectName: [
          { required: true, message: "请选择项目名称", trigger: "change" },
        ],
        module: [
          { required: true, message: "请选择项目模块", trigger: "change" },
        ],
        jobCode: [
          { required: true, message: "请选择工作类别", trigger: "change" },
        ],
        actualValue: [
          {
            required: true,
            message: "请输入投入工时",
            trigger: ["change", "blur"],
          },
        ],
        content: [
          { required: true, message: "请输入工作内容", trigger: "blur" },
        ],
      },
      idParam: "",
      pagination: { page: 1, size: 10, total: 0 }, // 分页参数
      loading: false, // 结果列表是否正在刷新
      dialogVisible: false, // 编辑窗口是否可见
      editDialogVisible: false, // 编辑窗口是否可见
      detailDialogVisible: false, // 详情窗口是否可见
    };
  },
  components: { LabelHeader },
  computed: {
    modules: function () {
      const set = new Set();
      this.plans.forEach(function (item, index, obj) {
        set.add(item.module);
      });
      return set;
    },
    jobs: function () {
      let ary = [];
      ary = moock.jobs;
      /* let that = this;
                if (this.plans.length > 0) {
                    this.plans.forEach(function (item, index, obj) {
                        if (that.entity.module && that.entity.module === item.module) {
                            ary.push({
                                value: item.jobCode,
                                label: item.jobName
                            });
                        }
                    });
                } */
      return ary;
    },
  },
  watch: {},
  // 页面加载获取数据
  mounted() {
    this.refresh();
  },
  methods: {
    clearSelect() {
      this.resetForm();
    },
    openEdit(row) {
      if (row) {
        this.entity = row;
      }
    },
    sizeChange(size) {
      this.pagination.size = size;
      this.search();
    },
    currentChange(pageNo) {
      this.pagination.page = pageNo;
      this.search();
    },
    refresh() {
      this.search();
    },
    querySearch(queryString, cb) {
      httpKit
        .post($api_pms.project.autocomplete, {
          keyword: queryString,
          pageSize: 100,
        })
        .then((res) => {
          if (res.data.code === "200") {
            this.projects = res.data.data;
            cb(this.projects);
            // this.closeAndRefreshParent();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    jobChange(val) {
      this.jobs.forEach((item, index) => {
        if (item.value === val) {
          this.entity.jobName = item.label;
        }
      });
    },
    handleSelect(item) {
      this.project = item;
      if (this.entity.projectCode !== this.project.code) {
        this.entity = this.resetWorkingHours(this.entity, this.project);
        this.queryPlans();
      }
    },
    handleSelects(item) {
      this.project = item;
      if (this.from.projectCode !== this.project.code) {
        this.from = this.resetWorkingHours(this.from, this.project);
        this.queryPlans();
      }
    },
    queryPlans() {
      httpKit
        .post($api_pms.plan.searchByPorject, { projectCode: this.project.code })
        .then((res) => {
          if (res.data.code === "200") {
            this.plans = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    openEditDialog(item) {
      if (item) {
        this.idVal = item.id;
        this.from = { ...item };
        this.dialogVisible = true;
      }
    },
    search(value) {
      const searchLoad = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.searchParams.pageNo = value ? value.page : this.pagination.page;
      this.searchParams.pageSize = value ? value.size : this.pagination.size;
      this.searchParams.sheetId = this.sheetId;

      httpKit
        .post($api_pms.sheetItem.sheet, this.searchParams)
        .then((res) => {
          searchLoad.close();
          if (res.data.code === "200") {
            this.items = res.data.data;
            this.pagination.total = res.data.totalItems;
          } else if (res.data.code === "500") {
            this.items = [];
            this.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          searchLoad.close();
        });
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "提交中,请稍后",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          httpKit
            .post($api_pms.sheetItem.save, this.entity)
            .then((res) => {
              loading.close();
              this.refreshCallback(res);
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    },
    saveEdit() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          httpKit
            .post($api_pms.sheetItem.save, this.from)
            .then((res) => {
              loading.close();
              if (res.data.code === "200") {
                this.idVal = "";
                this.$message({
                  showClose: true,
                  message: "修改成功",
                  type: "success",
                });
                this.refresh();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: "error",
                });
              }
              this.$nextTick(() => {
                this.$refs["editForm"].resetFields();
              });
            })
            .finally(() => {
              this.dialogVisible = false;
              this.refresh();
              loading.close();
            });
        }
      });
    },
    editClose() {
      this.idVal = "";
      this.dialogVisible = false;
    },
    handleClose(done) {
      this.idVal = "";
      done();
    },
    submit() {
      // if (this.$refs.form.valid().result) {this.save();}
      this.save();
    },
    deleteBatch() {
      let selection = this.$refs.table.getSelection();
      if (selection.length <= 0) {
        this.$message.error("请选择最少一条记录");
        return;
      }
      this.$confirm("您确定要删除这条记录吗？")
        .then(() => {
          let idAryStr = (parameter = selection[0].id);
          for (let i = 1; i < selection.length; i++) {
            idAryStr += "," + selection[i].id;
          }
          jsKit.delete({ ids: idAryStr }, $api_pms.druid.delete).then((res) => {
            this.deleteCallback(res);
          });
        })
        .catch((error) => {
          this.$message.error("取消");
        });
    },
    deleteRow(idVal) {
      jsKit.deleteByIdStr(
        $api_pms.sheetItem.delete,
        idVal,
        this.deleteCallback
      );
    },
    refreshCallback(res) {
      if (res.data.code === "200") {
        if (!this.entity.id) {
          this.$message.success("提交成功");
          // this.close();
        } else {
          this.$message.success("修改成功");
        }
        this.refresh();
        this.resetForm();
        this.$emit('success')
      } else if (res.data.code === "500") {
        this.$message.error("提交失败:" + res.data.msg);
      }
    },
    deleteCallback(res) {
      if (res.data.code === "200") {
        this.$message.success("已删除");
        this.refresh();
      } else if (res.data.code === "500") {
        this.$message.error("删除失败:" + res.data.msg);
      }
    },
    close() {
      this.$emit("close");
      this.resetForm();
    },
    resetForm() {
      this.entity = {
        sheetId: this.sheetId,
        module: "",
        jobCode: "",
        jobName: "",
        projectCode: "",
        projectName: "",
        actualValue: 8,
        createAt: "",
        content: "",
      };
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    resetWorkingHours(data, project) {
      data = {
        sheetId: this.sheetId,
        id: this.idVal,
        module: "",
        jobCode: "",
        jobName: "",
        projectCode: project.code,
        projectName: project.name,
        actualValue: 8,
        createAt: "",
        content: "",
      };

      return data;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 12px !important;
}
</style>
